// Kept in a dependency-free module rather than alongside the route config: routesConfig/login.js
// eagerly imports the Login and AutoLogin pages, which reach store/auth/actions and back into
// utils/action.js. Anything in that chain (utils/certificationAccess.js) that needed only the path
// strings closed the cycle and left catchAsyncActionError undefined at import time.
export const PATH_LOGIN = '/login';
export const PATH_AUTO_LOGIN = '/auto-login';
export const PATH_SSO_LOGIN = `${PATH_LOGIN}/sso`;
